module.exports = __webpack_public_path__ + "img/fx.f62df86d.png";